export default __webpack_public_path__ + "static/media/empty.ef3fd580.svg";